<template>
<div>
    <div v-html="field.etiqueta" :name="`process[${field.nombre}]`"></div>
</div>
</template>

<script>
    export default {
        name: "Paragraph",
        props: ['field'],
        data(){
            return {
                downloadedTemplate: this.field
            }
        },
    }
</script>

<style scoped>

</style>